import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiselectComponent from "../components/MultiselectComponent";
import {
  getInputColumnsData,
  getOutputColumnsData,
  saveAsMappings,
  getMappings,
  getEditStateData,
} from "../store/workspaceSlice";
import InputField from "../components/InputField";
import Button from "../components/Button";
import DropDownMenu from "../components/DropDownMenu";
import { rulesProperties, showAddedRulesToast } from "../helpers";
import { sortObjectByKeys } from "../utils";
import CheckBox from "../components/CheckBox";

const initialObject = {
  appliedRule: 12,
  useOutputOf: null,
  inputColumns: [],
  columnsToSum: {},
  columnMappings: {},
  outputTargetCol: [],
  skipZeroValues: false,
  skipEmptyCells: false,
};
const allowedRules = [
  1, // 1:GroupBy rule
  2, // 2:FindRule
];

const CreateColumnPairs = () => {
  const [columnPairObject, setColumnPairObject] = useState(initialObject);
  const [selectInputCols, setSelectInputCols] = useState();
  const [selectOutputCols, setSelectOutputCols] = useState();
  const outputColsData = useSelector(getOutputColumnsData);
  const [keyInput, setKeyInput] = useState("");
  const [valueInput, setValueInput] = useState("");
  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const inputColsData = useSelector(getInputColumnsData);
  const currentMaps = useSelector(getMappings);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);

  useEffect(() => {
    if (state?.type === "sumColumnPairs") {
      setColumnPairObject((prev) => ({
        ...prev,
        ...state.data,
      }));
      setSelectInputCols(
        state.data.inputColumns.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setSelectOutputCols(
        state.data.outputTargetCol.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setData(state?.data?.columnsToSum || {});
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const addKeyValue = () => {
    const trimmedKey = keyInput.trim();
    const trimmedValue = valueInput.trim();
    if (!trimmedKey || !trimmedValue) return;

    setData((prevData) => ({
      ...prevData,
      [trimmedKey]: prevData[trimmedKey]
        ? [...prevData[trimmedKey], trimmedValue]
        : [trimmedValue],
    }));

    setKeyInput("");
    setValueInput("");
  };

  const deleteKey = (key) => {
    const updatedData = { ...data };
    delete updatedData[key];
    setData(updatedData);
  };
  const handleColumnSelections = (selectedOptions, key) => {
    setColumnPairObject({
      ...columnPairObject,
      [key]: selectedOptions,
    });
  };
  const handleSetSelectOutputCols = (selectedOptions) => {
    setSelectOutputCols(selectedOptions);
    setColumnPairObject({
      ...columnPairObject,
      outputTargetCol: selectedOptions.map((sel) => sel.value),
    });
  };
  const handlesetselectInputcols = (selectedOptions) => {
    setSelectInputCols(selectedOptions);
    setColumnPairObject({
      ...columnPairObject,
      inputColumns: selectedOptions.map((sel) => sel.value),
    });
  };
  const handleAddNewRule = () => {
    const cleanedMappings = Object.fromEntries(
      Object.entries(columnPairObject?.columnMappings).filter(([key]) =>
        columnPairObject?.inputColumns.includes(key)
      )
    );
    const updatedSwitchObject = {
      ...columnPairObject,
      columnMappings: sortObjectByKeys(cleanedMappings),
    };

    dispatch(
      saveAsMappings({
        ...updatedSwitchObject,
        columnsToSum: data,
        // columnMappings: sortObjectByKeys(columnPairObject.columnMappings),
        // inputColumns: columnPairObject.inputColumns.map((obj) => obj.value),
        // outputTargetCol: columnPairObject.outputTargetCol.map(
        //   (obj) => obj.value
        // ),
      })
    );
    showAddedRulesToast(
      columnPairObject.appliedRule,
      isInLocalEditMode ? "Updated" : "added"
    ); // Show toast notification
    reset();
  };

  const reset = () => {
    setColumnPairObject(initialObject);
    setKeyInput("");
    setValueInput("");
    setData({});
    setSelectInputCols("");
    setSelectOutputCols("");
    setIsInLocalEditMode(false);
  };

  const handleOnChange = (e) => {
    setColumnPairObject((prev) => {
      return {
        ...prev,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
      };
    });
  };
  return (
    <div className="w-full">
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 m-2 p-2">
        <MultiselectComponent
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          selectedOptions={selectInputCols}
          handleSetSelect={handlesetselectInputcols} // Handle the selection change
          label={"Select Input Columns"}
          required={true}
        />
        <MultiselectComponent
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          selectedOptions={selectOutputCols}
          handleSetSelect={handleSetSelectOutputCols} // Handle the selection change
          label={"Select Output Columns"}
          required={true}
        />{" "}
        <DropDownMenu
          label={"Use Output of previous Rule"}
          name="useOutputOf"
          value={columnPairObject.useOutputOf || ""}
          options={currentMaps
            .filter((item) => allowedRules.includes(item.appliedRule))
            .map((item) => ({
              label: `${item._id} :  ${
                item.appliedRule
                  ? rulesProperties[item?.appliedRule].ruleName
                  : item.ruleName
              }`,
              value: parseInt(item._id),
            }))}
          onChange={handleOnChange}
          required={true}
        />
        {columnPairObject.outputTargetCol.length === 1 &&
          columnPairObject.inputColumns.length >= 1 && (
            <div className="col-span-2 flex justify-start items-end gap-x-8">
              <div className="min-h-10 flex">
                <CheckBox
                  name={"sameAsOutput"}
                  chkBoxText={"Same as output column"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setColumnPairObject((prevState) => ({
                        ...prevState,
                        columnMappings: Object.fromEntries(
                          Object.values(prevState.inputColumns).map(
                            (key) => [key, columnPairObject.outputTargetCol[0]] // 0 because will work if only one output column is selected
                          )
                        ),
                      }));
                    }
                  }}
                />
              </div>
            </div>
          )}
        {columnPairObject.outputTargetCol?.length > 0 &&
          columnPairObject.inputColumns?.length > 0 && (
            <div className="col-span-2 w-full p-2">
              <label className="font-semibold">
                Map switch columns to output column
              </label>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
                {columnPairObject.inputColumns.map((column) => (
                  <DropDownMenu
                    key={column}
                    label={column}
                    name={column}
                    required={true}
                    value={columnPairObject.columnMappings[column] || ""}
                    options={columnPairObject.outputTargetCol.map((col) => ({
                      label: col,
                      value: col,
                    }))}
                    onChange={(e) => {
                      // Update the switchColMappings state
                      setColumnPairObject((prevState) => ({
                        ...prevState,
                        columnMappings: {
                          ...prevState.columnMappings,
                          [column]: e.target.value || "",
                        },
                      }));
                    }}
                  />
                ))}
              </div>
            </div>
          )}
      </div>
      <h1 className="px-4">Create Column Pairs</h1>
      <div className=" mx-auto px-4 py-2 bg-white">
        <div className="w-full grid grid-cols-5 gap-4 items-end">
          <div className="col-span-2">
            <InputField
              // label={"Define Column (only character)"}
              name={"key"}
              type="text"
              placeholder={"Enter Pair Key"}
              value={keyInput}
              // toolTip="inputColumnName"
              onChange={(e) => setKeyInput(e.target.value)}
            />
          </div>
          <div className="col-span-2">
            <InputField
              // label={"Define Column (only character)"}
              name={"value"}
              type="text"
              placeholder={"Enter Column Name"}
              value={valueInput}
              onChange={(e) => setValueInput(e.target.value)}
            />
          </div>
          <div className="col-span-1">
            <button
              onClick={addKeyValue}
              className="bg-blue-500 text-white p-2 rounded w-full"
            >
              Add
            </button>
          </div>
        </div>

        <div className="mt-4 bg-gray-100 rounded h-52 overflow-auto">
          {data && Object.keys(data).length > 0
            ? Object.keys(data).map((key) => (
                <div
                  key={key}
                  className="flex items-center justify-between px-2 py-1 border rounded "
                >
                  <div>
                    <strong>{key}:</strong> {`[ ${data[key].join(", ")} ]`}
                  </div>
                  <button
                    onClick={() => deleteKey(key)}
                    className="bg-red-500 text-white p-1 rounded"
                  >
                    Delete
                  </button>
                </div>
              ))
            : "No data Founds"}
        </div>
      </div>
      <div className="px-4 py-2 col-span-2 flex justify-start items-center gap-x-8">
        <div className="min-h-10 flex">
          <CheckBox
            name={"skipEmptyCells"}
            chkBoxText={"Skip Empty Cells"}
            checked={columnPairObject.skipEmptyCells}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
        </div>
        <div className="min-h-10 flex">
          <CheckBox
            name={"skipZeroValues"}
            chkBoxText={"Skip Zero Values"}
            checked={columnPairObject.skipZeroValues}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
        </div>
      </div>
      <div className="mt-4 col-span-2 flex gap-2 px-2">
        <Button
          disabled={
            columnPairObject.inputColumns.length === 0 ||
            columnPairObject.outputTargetCol.length === 0 ||
            !columnPairObject?.useOutputOf
          }
          btnType="save"
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
        />
        <Button btnType="cancel" btnText={"Reset"} handleOnClick={reset} />
      </div>
    </div>
  );
};

export default CreateColumnPairs;
